import { loadDurationValidity } from 'Utils/option-validity/OptionValidityUtils';
import createAction from 'Store/utils/createAction';
import { SET_OPTION_VALIDITY, UNSET_OPTION_VALIDITY } from './optionValidity.reducer';
export const setOptionValidity = (appContext: AppContext) => {
  return async (dispatch: ReduxDispatch) => {
    const data = await loadDurationValidity(appContext);
    return dispatch(createAction(SET_OPTION_VALIDITY, data));
  };
};
export const unsetOptionValidity = () => createAction(UNSET_OPTION_VALIDITY);
